import React from 'react'

import Breadcrumbs from 'components/Breadcrumbs'
import RegionOverview from 'components/RegionOverview'
import RegionChangerController from 'modules/Controllers/RegionChanger/RegionChangerController'
import LayerHeaderMap from 'modules/Charts/Map/LayerHeaderMap'
import Config from 'utils/config'

const LayerHeader = () => {
  let regionChangeController;

  if ( Config.getProperty( "enable_region_change", true ) ) {
    regionChangeController = <RegionChangerController />;
  }
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12 col-md-9">
          <Breadcrumbs responsive={false} />
          <RegionOverview />
        </div>
        <div className="col-sm-6 col-sm-offset-3 col-md-3 col-md-offset-0 ork-region-changing">
          <LayerHeaderMap />
          {regionChangeController}
        </div>
      </div>
    </div>
  )
}

export default LayerHeader



// WEBPACK FOOTER //
// ./src/components/LayerHeader/LayerHeader.js